import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { _ } from 'vue-underscore';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Daftar Stok Masuk',
    title_form: 'Form Stok Masuk',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Stok Masuk',
        href: '/adm/logistic/stok-masuk',
        active: true,
      },
    ],
    tab: [
      {
        name: 'Supplier',
        active: true,
      },
      {
        name: 'Kode Akun dan HPP',
        active: false,
      },
    ],
    formProduct: {
      name: '',
      stock: '',
      min_stock: '',
      unit: '',
      price_buy: '',
      price_sale: '',
      brand: '',
      supplier_product: [
        {
          id_supplier: '',
          name_supplier: '',
          price_buy: '',
          disc: '',
          ppn: '',
          price_final: '',
        },
        {
          id_supplier: '',
          name_supplier: '',
          price_buy: '',
          disc: '',
          ppn: '',
          price_final: '',
        },
      ],
    },
    items: [
      {
        id: 1,
        kode: 'MS00121090001',
        purchase_no: 'PO00121090001',
        supplier: 'PT AMERTA INDAH JAYA',
        tgl_beli: '2021-09-01',
        tgl_masuk: '2021-09-01',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        uang_muka: 1000000,
        sisa_hutang: 3200000,
        status: 'not paid',
        jenis: 'jasa',
        kode_produk: 'B1101',
        produk: 'Penjepit Kertas',
        satuan: 'pcs',
        qty: 5,
        merk: 'Kenko',
      },
      {
        id: 2,
        kode: 'MS00121090002',
        purchase_no: 'PO00121090001',
        supplier: 'PT SEJAHTERA JAYA',
        tgl_beli: '2021-09-01',
        tgl_masuk: '2021-09-01',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        uang_muka: 1000000,
        sisa_hutang: 3200000,
        status: 'paid',
        jenis: 'produk',
        kode_produk: 'B1102',
        produk: 'Solar',
        satuan: 'liter',
        qty: 3000,
        merk: 'Pertamina',
      },
      {
        id: 3,
        kode: 'MS00121090003',
        purchase_no: 'PO00121090001',
        supplier: 'PT TIRTA JAYA',
        tgl_beli: '2021-09-01',
        tgl_masuk: '2021-09-01',
        total: 3900000,
        biaya_lain: 100000,
        pajak: 200000,
        total_final: 4200000,
        uang_muka: 1000000,
        sisa_hutang: 3200000,
        status: 'paid',
        jenis: 'jasa',
        kode_produk: 'B1103',
        produk: 'Kertas Ukuran A4',
        satuan: 'pack',
        qty: 100,
        merk: 'Sinar Dunia',
      },
    ],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'kode',
        label: 'Stok No',
        sortable: true,
      },
      {
        key: 'purchase_no',
        label: 'Pembelian',
        sortable: true,
      },
      {
        key: 'tgl_beli',
        label: 'Tgl Beli',
        sortable: true,
      },
      {
        key: 'tgl_masuk',
        label: 'Tgl Masuk',
        sortable: true,
      },
      {
        key: 'kode_produk',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'produk',
        label: 'Produk',
      },
      {
        key: 'qty',
        label: 'Jumlah',
      },
      {
        key: 'satuan',
        label: 'Satuan',
      },
      {
        key: 'merk',
        label: 'Merk',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
  },
};

export const getters = {
  form(state) {
    return state.data.formProduct;
  },
  activeTab(state) {
    let tabActive = _.findWhere(state.data.tab, {
      active: true,
    });

    return tabActive ? tabActive.name : '';
  },
};

export const mutations = {
  changeStokMasuk(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchCustomer(context, params = null) {
    let result = await ApiGetRequest(`logistic/suppliers`, params);
    return !result.error ? result.data.object : [];
  },

  async getListCustomer({ commit, state }) {
    commit('changeStokMasuk', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      _limit: data.limit,
      _page: data.page,
      _sort: data.sortBy,
      _order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/suppliers`, params);
    commit('changeStokMasuk', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailCustomer({ commit }, payload = null) {
    commit('changeStokMasuk', {
      loading: true,
    });

    let result = await ApiGetRequest(`logistic/suppliers/${payload.id}`);
    commit('changeStokMasuk', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async createCustomer({ commit, state, dispatch }) {
    commit('changeStokMasuk', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/suppliers`, state.data.form);
    commit('changeStokMasuk', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateCustomer({ commit, state, dispatch }, payload = null) {
    commit('changeStokMasuk', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/suppliers/${payload.id}`,
      state.data.form
    );

    commit('changeStokMasuk', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteCustomer({ commit, dispatch }, payload = null) {
    commit('changeStokMasuk', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/suppliers/${payload.id}`);
    commit('changeStokMasuk', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
